<ng-container *ngIf="!isLoading">
    <div class="share_links">
        <div class="wrap_all" @fadeWithMoveY>
            <div class="wrap_close text-center">
                <app-close (click)="CloseBox()"></app-close>
            </div>
        
            <div class="wrap">
                <div class="wrap_content label_lg_bold">
                    <h3 class="text-center mb-3 font_24">فتح الصفحة في التطبيق</h3>
                    <div class="wrap_apps my-0 mx-auto">
                        <div class="wrap_box">
                            <a [href]="DeepLink" class="a_none d-flex justify-content-between main_color">
                                <span class="app_name d-inline-block margin_end_3">
                                    تطبيق ساعي
                                    <br>
                                    Saaei ( App )
                                </span>
                                <img src="assets/img/logo_crop.svg" width="50" height="52" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>    
</ng-container>